import { loadImage, createCanvas, addLogo } from "./utils.js";

const addLogoImage = async (
  photo,
  position,
  size,
  logoSrc,
  photoId,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  setAllPhotos,
  setAcceptedPhotos
) => {
  // Check if we already have the original image for this photo
  if (!originalImagesLogo[photoId]) {
    originalImagesLogo[photoId] = photo.url.url; // Store the original image URL
    setOriginalImagesLogo((prev) => ({
      ...prev,
      [photoId]: photo.url.url,
    }));
  }
  try {
    const originalImage = await loadImage(originalImagesLogo[photoId]);
    const canvas = createCanvas(originalImage.width, originalImage.height);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(originalImage, 0, 0);

    // Clear the canvas and redraw the original image
    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
    ctx.drawImage(originalImage, 0, 0); // Redraw the original image
    // Draw the new logo
    const logoPositionData = await addLogo(
      ctx,
      size,
      position,
      Math.min(originalImage.width, originalImage.height),
      logoSrc
    );
    // Create new image URL
    const newImageSrc = canvas.toDataURL("image/jpeg");

    setAcceptedPhotos((prevPhotos) => {
      // Check if the photoId exists in originalImages
      const existsInOriginal = originalImages.hasOwnProperty(photoId);
      // Determine the new edit attributes
      const newEditAttributes = {
        assetId: existsInOriginal
          ? prevPhotos.find((photo) => photo.photoId === photoId)?.edit.assetId
          : null,
        x0: existsInOriginal
          ? prevPhotos.find((photo) => photo.photoId === photoId)?.edit.x0
          : null,
        y0: existsInOriginal
          ? prevPhotos.find((photo) => photo.photoId === photoId)?.edit.y0
          : null,
        x1: existsInOriginal
          ? prevPhotos.find((photo) => photo.photoId === photoId)?.edit.x1
          : null,
        y1: existsInOriginal
          ? prevPhotos.find((photo) => photo.photoId === photoId)?.edit.y1
          : null,
        logoX: logoPositionData.x, // Always set to the new value
        logoY: logoPositionData.y, // Always set to the new value
        widthLogo: logoPositionData.width, // Always set to the new value
        heightLogo: logoPositionData.height, // Always set to the new value
      };
      
       console.log(newEditAttributes);
      // Check if the photo already exists in acceptedPhotos
      const existingPhotoIndex = prevPhotos.findIndex(
        (photo) => photo.photoId === photoId
      );

      if (existingPhotoIndex !== -1) {
        // If it exists, update the photo
        const updatedPhotos = [...prevPhotos];
        updatedPhotos[existingPhotoIndex] = {
          photoId,
          edit: newEditAttributes,
        };
        return updatedPhotos;
      } else {
        // If it doesn't exist, add a new photo
        return [
          ...prevPhotos,
          {
            photoId,
            edit: newEditAttributes,
          },
        ];
      }
    });
    setAllPhotos((prevPhotos) =>
      prevPhotos.map((p) =>
        p.id === photoId
          ? {
              ...p,
              url: { ...p.url, url: newImageSrc }, // Update to the new image
              logoSize: size,
              logoPosition: position,
            }
          : p
      )
    );
  } catch (error) {
    console.error("Error processing images:", error);
  }
};

export default addLogoImage;
